import React from 'react';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';

const Footer: React.FC = () => {
  const handleAppStoreClick = (e: React.MouseEvent) => {
    e.preventDefault();
    toast.success('We are launching soon on Apple Store! Stay tuned for updates.');
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-8 h-8 bg-gradient-to-r from-primary-600 to-purple-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-sm">C</span>
              </div>
              <span className="text-xl font-bold">CodeSpirit</span>
            </div>
            <p className="text-gray-400 mb-4 max-w-md">
              Your gateway to amazing tech events, hackathons, and innovation. Connect with developers, 
              designers, and creators from around the world.
            </p>

            {/* Mobile App Downloads */}
            <div className="mb-6">
              <h4 className="text-sm font-semibold text-gray-300 mb-3">Download Our Mobile App</h4>
              <div className="flex flex-col sm:flex-row gap-3">
                {/* Google Play Store */}
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    // Add your Play Store link here
                    window.open('https://play.google.com/store/apps/details?id=com.codespirit.app', '_blank');
                  }}
                  className="flex items-center gap-2 bg-gray-800 hover:bg-gray-700 px-4 py-2 rounded-lg transition-colors duration-200 w-fit"
                >
                  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.61 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
                  </svg>
                  <div className="text-left">
                    <div className="text-xs text-gray-400">GET IT ON</div>
                    <div className="text-sm font-medium">Google Play</div>
                  </div>
                </a>

                {/* App Store with Coming Soon */}
                <button
                  onClick={handleAppStoreClick}
                  className="flex items-center gap-2 bg-gray-800 hover:bg-gray-700 px-4 py-2 rounded-lg transition-colors duration-200 w-fit"
                >
                  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M18.71,19.5C17.88,20.74 17,21.95 15.66,21.97C14.32,22 13.89,21.18 12.37,21.18C10.84,21.18 10.37,21.95 9.1,22C7.79,22.05 6.8,20.68 5.96,19.47C4.25,17 2.94,12.45 4.7,9.39C5.57,7.87 7.13,6.91 8.82,6.88C10.1,6.86 11.32,7.75 12.11,7.75C12.89,7.75 14.37,6.68 15.92,6.84C16.57,6.87 18.39,7.1 19.56,8.82C19.47,8.88 17.39,10.1 17.41,12.63C17.44,15.65 20.06,16.66 20.09,16.67C20.06,16.74 19.67,18.11 18.71,19.5M13,3.5C13.73,2.67 14.94,2.04 15.94,2C16.07,3.17 15.6,4.35 14.9,5.19C14.21,6.04 13.07,6.7 11.95,6.61C11.8,5.46 12.36,4.26 13,3.5Z"/>
                  </svg>
                  <div className="text-left">
                    <div className="text-xs text-gray-400">Download on the</div>
                    <div className="text-sm font-medium">App Store</div>
                  </div>
                </button>
              </div>

              {/* Direct APK Download */}
              <div className="mt-3">
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    // Add your APK download logic here
                    const link = document.createElement('a');
                    link.href = '/path-to-your-app.apk'; // Replace with actual APK path
                    link.download = 'codespirit.apk';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    toast.success('APK download started!');
                  }}
                  className="inline-flex items-center gap-1 text-sm text-gray-400 hover:text-white transition-colors"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  Direct APK Download
                </a>
              </div>
            </div>

            {/* Social Links */}
            <div className="flex space-x-4">
              <a href="https://x.com/codespirit_in" target="_blank" rel="noopener noreferrer"  className="text-gray-400 hover:text-white transition-colors duration-200">
                <span className="sr-only">Twitter</span>
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                </svg>
              </a>
              <a href="https://github.com/CodeSpirit_in" target="_blank" rel="noopener noreferrer"  className="text-gray-400 hover:text-white transition-colors duration-200">
                <span className="sr-only">GitHub</span>
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path fillRule="evenodd" d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" clipRule="evenodd" />
                </svg>
              </a>
              <a href="https://linkedin.com/company/codespirit" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors duration-200">
                <span className="sr-only">LinkedIn</span>
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
              </a>

               {/* YouTube */}
  <a href="https://youtube.com/codespirit-in" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-red-500 transition-colors duration-200">
    <span className="sr-only">YouTube</span>
    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
      <path d="M19.615 3.184c-1.63-.434-8.157-.434-8.157-.434s-6.527 0-8.157.434C1.55 3.63 1.5 6.897 1.5 12s.05 8.37 1.801 8.816c1.63.434 8.157.434 8.157.434s6.527 0 8.157-.434C22.45 20.37 22.5 17.103 22.5 12s-.05-8.37-1.801-8.816zM10 15.5v-7l6 3.5-6 3.5z"/>
    </svg>
  </a>

  {/* Discord */}
  <a href="https://discord.gg/Zs5CtZsc" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-indigo-500 transition-colors duration-200">
    <span className="sr-only">Discord</span>
    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
      <path d="M20 0H4C1.79 0 0 1.79 0 4v16c0 2.21 1.79 4 4 4h12l-1.1-3.7 2.6 2.4 2.5 2.3 4-4V4c0-2.21-1.79-4-4-4zM8.45 15.3c-1.03 0-1.87-.9-1.87-2s.84-2 1.87-2c1.03 0 1.87.9 1.87 2s-.84 2-1.87 2zm7.1 0c-1.03 0-1.87-.9-1.87-2s.84-2 1.87-2 1.87.9 1.87 2-.84 2-1.87 2z"/>
    </svg>
  </a>

  {/* Instagram */}
  <a href="https://instagram.com/codespirit.in" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-pink-500 transition-colors duration-200">
    <span className="sr-only">Instagram</span>
    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
      <path d="M7.75 2h8.5A5.75 5.75 0 0122 7.75v8.5A5.75 5.75 0 0116.25 22h-8.5A5.75 5.75 0 012 16.25v-8.5A5.75 5.75 0 017.75 2zm0 1.5A4.25 4.25 0 003.5 7.75v8.5A4.25 4.25 0 007.75 20.5h8.5a4.25 4.25 0 004.25-4.25v-8.5A4.25 4.25 0 0016.25 3.5h-8.5zm8.75 2a1 1 0 110 2 1 1 0 010-2zM12 7a5 5 0 110 10 5 5 0 010-10zm0 1.5a3.5 3.5 0 100 7 3.5 3.5 0 000-7z"/>
    </svg>
  </a>
  {/* WhatsApp Channel */}
<a
  href="https://whatsapp.com/channel/0029VapOKPqHAdNXNTwL2I1M"
  target="_blank"
  rel="noopener noreferrer"
  className="text-gray-400 hover:text-green-500 transition-colors duration-200"
  aria-label="Follow our WhatsApp Channel"
>
  <span className="sr-only">WhatsApp Channel</span>
  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M20.52 3.48A11.94 11.94 0 0012.06 0C5.46 0 .1 5.36.1 11.97c0 2.11.55 4.19 1.61 6.02L0 24l6.18-1.63a11.93 11.93 0 005.88 1.57h.01c6.6 0 11.96-5.36 11.96-11.96 0-3.2-1.25-6.2-3.51-8.5zM12.06 21.4h-.01a9.4 9.4 0 01-4.79-1.31l-.34-.2-3.67.97.98-3.58-.22-.37a9.43 9.43 0 01-1.42-4.94c0-5.19 4.23-9.41 9.43-9.41 2.52 0 4.89.98 6.68 2.76a9.38 9.38 0 012.75 6.66c0 5.19-4.23 9.42-9.39 9.42zm5.42-6.96c-.3-.15-1.77-.88-2.05-.98-.27-.1-.47-.15-.67.15-.2.3-.77.98-.95 1.18-.17.2-.35.22-.64.07-.3-.15-1.25-.46-2.38-1.47-.88-.78-1.47-1.75-1.65-2.04-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.38-.02-.53-.07-.15-.67-1.61-.92-2.2-.24-.58-.49-.5-.67-.5h-.57c-.2 0-.52.08-.79.38-.27.3-1.04 1.02-1.04 2.48 0 1.46 1.06 2.87 1.21 3.06.15.2 2.09 3.19 5.08 4.46.71.31 1.26.5 1.69.64.71.23 1.36.2 1.87.12.57-.08 1.77-.72 2.02-1.43.25-.71.25-1.32.18-1.45-.07-.13-.27-.2-.57-.35z"/>
  </svg>
</a>

            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-5">Quick Links</h3>
            <ul className="space-y-2">
               <li>
                <Link to="/events" className="text-gray-400 hover:text-white transition-colors duration-200">
                  Events
                </Link>
              </li>
               <li>
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors duration-200">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/hackathons" className="text-gray-400 hover:text-white transition-colors duration-200">
                  Hackathons
                </Link>
              </li>
              <li>
                <Link to="/create-hackathon" className="text-gray-400 hover:text-white transition-colors duration-200">
                  Promote your Hackathon
                </Link>
              </li>    
              
               <li>
                <a href="https://whatsapp.com/channel/0029VapOKPqHAdNXNTwL2I1M" className="text-gray-400 hover:text-white transition-colors duration-200">
                  Join CodeSpirit's WhatsApp Channel
                </a>
              </li>
               <li>
                <a href="https://forms.gle/NXWPnYgYyvV76LHZ8" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors duration-200">
                  Join CodeSpirit's Campus Manager
                </a>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Support</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/help" className="text-gray-400 hover:text-white transition-colors duration-200">
                  Help Center
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors duration-200">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-gray-400 hover:text-white transition-colors duration-200">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-400 hover:text-white transition-colors duration-200">
                  Terms of Service
                </Link>
              </li>
              <li>
                <a href="https://elite-founders.vercel.app" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors duration-200">
                  Join CodeSpirit Elite Founder's Network
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2025 CodeSpirit. All rights reserved.
            </p>
            {/* <p className="text-gray-400 text-sm mt-2 md:mt-0">
              Made with ❤️ for the developer community
            </p> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;